import { NavLink } from "react-router-dom";

export function Navbar() {

    return (
        <nav className="bg-gray-800 py-4 border-b-2 drop-shadow-2xl border-yellow-500 rounded-b-md">
            <ul className="flex justify-center space-x-8">
                <li>
                    <NavLink to="/" className="text-blue-300 hover:text-white">
                        Accueil
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/trouver_film" className="text-gray-300 hover:text-white">
                        Trouver votre film
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/recommandation_par_genre" className="text-gray-300 hover:text-white">
                        Recommandation par Genre
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/recommandation_par_annee" className="text-gray-300 hover:text-white">
                        Recommandation par Année
                    </NavLink>
                </li>
            </ul>
        </nav>
    )
}